module.exports = __webpack_public_path__ + "static/media/LUXEIN.187d52f6.svg";